<template>
  <modal
    v-bind="{
      ...$attrs,
      ...attrs.extra,
    }"
    v-on="$listeners"
    :styles="style.modal"
  >
    <div
      :class="$style.container"
      :style="style.container"
    >
      <slot />
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'BaseVueJsModal',
    inheritAttrs: false,
    props: {
      hideOverflow: {
        type: Boolean,
        reuqired: false,
        default: false,
      },
      styleConfig: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        attrs: {
          extra: {
            classes: this.hideOverflow? '': 'vm--modal-override-overflow-visible',
          },
        },
        style: {
          container: {},
          modal: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.container,
        this.styleConfig.container,
      );

      Object.assign(
        this.style.modal,
        this.styleConfig.modal,
      );
    },
  };
</script>

<style lang="stylus">
  .vm--modal-override-overflow-visible
    overflow visible

  .vm--overlay
    width 100vw
    &:hover
      background-color rgba(0, 0, 0, 0.2)
</style>

<style lang="stylus" module>
  .container
    background-color var(--v2-base-vue-js-modal-background-color)
    border var(--v2-base-vue-js-modal-border)
    border-radius var(--v2-base-vue-js-modal-border-radius)
    border-width var(--v2-base-vue-js-modal-border-width)
    box-shadow var(--v2-base-vue-js-modal-box-shadow)
</style>
